module.exports = __webpack_public_path__ + "static/media/404-image.fe160839.png";